const measurementMapTranslations = {
  SQUARE_FOOT: "area.feet",
  SQUARE_YARD: "area.yards",
  LINEAR_FOOT: "perimeter.feet",
  UNIT: "",
};
export default measurementMapTranslations;
